export const UNBREAKABLE_THIN_SPACE_CHAR = '\u202F';

export const toThousandSeparatedNumber = (number, separator = UNBREAKABLE_THIN_SPACE_CHAR) =>
  number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator).replace(/\./g, ',');

export const replaceWhitespaceWithNonBreakableSpace = text => (
  text.replace(/ /g, '\u00a0')
);

export const replaceDots = number => number.toString().replace(/\./g, ',');

export const toThousandSeparatedSumma = summa => toThousandSeparatedNumber(summa) + UNBREAKABLE_THIN_SPACE_CHAR;

export const getFormattedText = (count, words) => {
  const remainder = count % 10;
  const remainderH = count % 100;

  if (remainderH >= 11 && remainderH <= 19) {
    return words[2];
  }

  switch (remainder) {
    case 1:
      return words[0];
    case 2:
    case 3:
    case 4:
      return words[1];
    default:
      return words[2];
  }
};

export const parseSum = (sumStr) => {
  const trimed = sumStr.split(' ').join('');
  if (!trimed) {
    return 0;
  }
  const parsed = Number.parseFloat(trimed);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const reload = () => window.location.reload();

export const openNewTab = url => window.open(url, '_blank');

export const popupWindow = (url, title, width, height) => {
  const y = ((window.top.outerHeight - height) / 2) + window.top.screenY;
  const x = ((window.top.outerWidth - width) / 2) + window.top.screenX;
  return window.open(url, title, `width=${width}, height=${height}, top=${y}, left=${x}`);
};

export const getAdMarkText = (nameText, name, innText, inn, erirText, erir) => (
  [[name, nameText], [inn, innText], [erir, erirText]]
    .filter(ar => !!ar[0])
    .map(([value, text]) => text + value)
    .join(', ')
);
